export const TAB_NAMES = ['basic', 'standard', 'premium', 'custom'];
export const UPPER_PACKAGES = 'Upper Packages';
export const customOrderPackage = { id: 4 };
